import React from 'react';
import Text from 'components/Text/Text';
import { Checkbox, Form } from 'antd';

interface IProps {
	toggleActivateBPA: () => void;
	isActiveBpa: boolean;
}

export const ActivateBPACheckBox: React.FC<IProps> = React.memo(({ toggleActivateBPA, isActiveBpa }) => {
	return (
		<Form.Item name="isActiveBpa" data-test="ActivateBPACheckBox">
			<Checkbox checked={isActiveBpa} onChange={toggleActivateBPA}>
				<Text translationNameSpace="form" translationKey="activateBPALabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
});
